export default __webpack_public_path__ + "static/invitationVideo-b889b2fb340da0d4373aa95a82b48b49.webm";